// @flow
import CentenaireFormOkModalContent from 'components/fragments/modal/modalContents/CentenaireFormOkModalContent';
import { connect } from 'react-redux';

import { displayModal } from 'actions/modalActions';
import type { DispatchProps } from 'components/fragments/modal/modalContents/CentenaireFormOkModalContent';
import type { DispatchType } from 'types/Actions';

export default connect(null, (dispatch: DispatchType): DispatchProps => ({
  displayModal: (modalObject: string) => dispatch(displayModal(modalObject))
}))(CentenaireFormOkModalContent);
